import { useEffect, useState } from 'react';

import { ChevronLeft, ChevronRight } from '@gympass/yoga-icons';

import { Direction, PaginatorProps } from './types';

import * as S from './styles';

export const Paginator: React.FC<PaginatorProps> = ({
  next,
  previous,
  lastPage = 1,
  startPage,
}) => {
  const [currentPage, setCurrentPage] = useState(startPage || 1);

  useEffect(() => {
    if (startPage) setCurrentPage(startPage);
  }, [startPage]);

  const onClick = (state: Direction) => {
    try {
      if (state === 'next') {
        if (currentPage >= lastPage) return;

        next?.(currentPage);
        setCurrentPage(prev => prev + 1);
        return;
      }

      if (currentPage <= 1) return;

      previous?.(currentPage);
      setCurrentPage(prev => prev - 1);
    } catch (error) {
      throw new Error('[Paginator][onClickPrevious]');
    }
  };

  return (
    <S.PaginationContainer data-testid="paginator">
      <S.NotesButton
        onClick={() => {
          onClick('previous');
        }}
        data-testid="paginator-previous"
      >
        <ChevronLeft
          fill={currentPage === 1 ? '#8383A3' : '#710252'}
          width={31}
          height={31}
        />
      </S.NotesButton>
      <S.PaginationItem data-testid="paginator-current">
        {currentPage}
      </S.PaginationItem>
      <S.PaginationItem>/</S.PaginationItem>
      <S.PaginationItem>{lastPage === 0 ? 1 : lastPage}</S.PaginationItem>
      <S.NotesButton
        onClick={() => {
          onClick('next');
        }}
        data-testid="paginator-next"
      >
        <ChevronRight
          fill={currentPage === lastPage ? '#8383A3' : '#710252'}
          width={31}
          height={31}
        />
      </S.NotesButton>
    </S.PaginationContainer>
  );
};
